module.exports = __webpack_public_path__ + "img/papper-blue.e711f809.svg";